import { toast } from 'react-toastify';
export function checkError(err) {
    if (err && !err.response) {
      // alert(err);
    }
    else if (err?.response?.status === 401) {
        const url = err.config?.url || '';
        const isAffiliateRequest = url.includes('/affiliate') || url.includes('/withdrawal') || url.includes('/order/affiliate');
        const isCustomerRequest = url.includes('/user') || url.includes('/cart') || url.includes('/review') || (url.includes('/order') && !url.includes('/order/affiliate'));
        
        let isAffiliate = false;
        if (isAffiliateRequest) {
            isAffiliate = true;
        } else if (isCustomerRequest) {
            isAffiliate = false;
        } else {
            isAffiliate = window.location.pathname.includes('affiliate');
        }

        if (isAffiliate) {
            sessionStorage.removeItem('affiliateToken');
            sessionStorage.removeItem('loggedAffiliate');
            if (window.location.pathname !== '/affiliate-login') {
                window.location.href = "/affiliate-login";
            }
        } else {
            sessionStorage.removeItem('userToken');
            sessionStorage.removeItem('loggedUser');
            if (window.location.pathname !== '/login') {
                window.location.href = "/login";
            }
        }
    } else if (err?.response?.status === 500) {
        // window.location.href = process.env.REACT_APP_WEB_URL + "/#/error-500";
    }
    toast.error(err?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored"
    });
}

export const apiTimeout = (promise, p=30000) => {
    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error('Request timed out'));
      }, p);

      promise
        .then((response) => {
          clearTimeout(timeoutId);
          resolve(response);
        })
        .catch((error) => {
          clearTimeout(timeoutId);
          reject(error);
        });
    });
  };